module.exports = __webpack_public_path__ + "files/c4f6f9137279e0dab0f68c15343a10df.png";